let id = 1;
let idGenerate = () => {
    return (id++).toString();
};
function setIdGenerateFn(fn) {
    idGenerate = fn;
}
function generateId() {
    return idGenerate();
}
function getDefaultsContent(content = {}) {
    let result = {
        text: '',
        video: [],
        audio: [],
        image: [],
        richText: '',
        allowPhotoNum: 0,
        allowMinPhotoNum: 0,
        allowFileTypes: []
    };
    return Object.assign({}, result, content);
}
function getTextByList(list, defaultText, getTextCb) {
    let n = 1;
    let text = `${defaultText}${n}`;
    while (list.find(r => {
        let temp = getTextCb(r);
        return temp === text;
    })) {
        text = `${defaultText}${++n}`;
    }
    return text;
}

function deepClone(obj) {
    const nullValues = [null, undefined, NaN, false];
    if (nullValues.includes(obj))
        return obj;
    if (typeof obj !== 'object' && typeof obj !== 'function') {
        // 原始类型直接返回
        return obj;
    }
    const o = Array.isArray(obj) ? [] : {};
    for (const i in obj) {
        // @ts-ignore
        if (obj.hasOwnProperty(i)) {
            o[i] = typeof obj[i] === 'object' ? deepClone(obj[i]) : obj[i];
        }
    }
    return o;
}
/**
 *
 * @param data
 * @param ignoreAttrs 需要忽略的key
 */
function assign(data, ignoreAttrs = []) {
    const results = {};
    for (const key in data) {
        if (!ignoreAttrs.includes(key)) {
            results[key] = data[key];
        }
    }
    return results;
}
/**
 * 返回 foo=1&bar=2
 * @param obj
 */
function convertObjToUrlSearch(obj) {
    const kvs = [];
    for (const key in obj) {
        const value = obj[key];
        if (value === 'undefined' || value === 'null')
            continue;
        kvs.push(`${key}=${value}`);
    }
    return kvs.join('&');
}
function getObjFactory(objs) {
    return function (type) {
        let s = Object.keys(objs).find(key => {
            let t = objs[key].type;
            if (Array.isArray(t)) {
                return t.includes(type);
            }
            else {
                return t === type;
            }
        });
        if (!s) {
            return null;
        }
        return objs[s];
    };
}

let g_id = 1;
function initItems(items = []) {
    return items.map(item => {
        if (!item.content.richText) {
            item.content.richText = item.content.text;
        }
        if (!item.setting) {
            item.setting = {
                enableRelation: false
            };
        }
        return Object.assign({ validate: null }, item);
    });
}
function convertGroups(items) {
    return items.map(item => {
        return Object.assign({
            groupId: g_id++
        }, item);
    });
}
function createItem(text) {
    return {
        id: generateId(),
        content: getDefaultsContent({
            text: text,
            richText: text,
            allowPhotoNum: 0
        }),
        is_other_item: 0,
        is_exclusive: false,
        validate: null,
        maxLength: '',
        minLength: '',
        required: true,
        tips: '',
        setting: {
            enableRelation: false
        }
    };
}
class Choice {
    constructor(data) {
        this.correct_answer = data.correct_answer || []; // 质控题正确答案
        this.items = initItems(data.items || []);
        this.is_rand = data.is_rand || false;
        this.randList = data.randList || [];
        this.choice_num_per_row = data.choice_num_per_row || 1;
        this.item_groups = convertGroups(data.item_groups || []);
        this.append_items = data.append_items || [];
    }
    getParams(ignoreKeys = []) {
        return assign(this, ignoreKeys);
    }
    addItem() {
        const text = getTextByList(this.items, '选项', item => {
            return item.content.text;
        });
        this.addItems([text]);
    }
    addItems(texts) {
        const items = texts.map(createItem);
        this.items.push(...items);
    }
    addOtherItem() {
        let item = createItem('其他');
        item.is_other_item = 1;
        this.items.push(item);
    }
}

function transformGroupsByLevel(groups = [], level = 3) {
    const isLast = level - 1 === 0;
    for (let i = 0; i < groups.length; i++) {
        const group = groups[i];
        if (isLast) {
            group.nextLevelOptions = null;
            group.isNextLevel = false;
        }
        else {
            transformGroupsByLevel(group.nextLevelOptions, level - 1);
        }
    }
}
function getValueByIds(groups = [], ids = [], isRoot = false, parent) {
    for (let i = 0; i < groups.length; i++) {
        const group = groups[i];
        if (group.nextLevelOptions && group.nextLevelOptions.length) {
            getValueByIds(group.nextLevelOptions.slice(), ids, false, group);
        }
        if (!isRoot) {
            ids.forEach(val => {
                let index = val.findIndex((item) => {
                    if (!item)
                        return false;
                    return item.id === group.id;
                });
                if (index !== -1) {
                    val[index] = {
                        id: group.id,
                        content: group.content
                    };
                    val.unshift({
                        id: parent.id,
                        content: parent.content
                    });
                }
            });
        }
        else {
            ids.forEach(val => {
                if (val.length === 1) {
                    let find = groups.find(g => g.id === val[0].id);
                    if (find) {
                        val[0].content = find.content;
                    }
                }
            });
        }
    }
    return ids;
}
const CascadeStyleType = {
    One: 1,
    Many: 2
};
class Cascade {
    constructor(data) {
        this.groups = data.groups || [];
        this.levelsNum = data.levelsNum || 0;
        this.levels = (data.levels || []).filter(Boolean);
        this.prompt = data.prompt || '';
        this.fillContext = data.fillContext || [];
        this.requiredNum = data.requiredNum || this.levelsNum;
        this.styleType = data.styleType || CascadeStyleType.Many;
    }
    getGroupsByLevel(n) {
        if (!n || n < 0) {
            n = Math.min(this.levelsNum, this.requiredNum);
        }
        const groups = deepClone(this.groups);
        transformGroupsByLevel(groups, n);
        return groups;
    }
    getValueByLastIds(ids = []) {
        return this.getValueByIds(ids).map(item => item.map((i) => i.id));
    }
    getTextByLastIds(ids = []) {
        return this.getValueByIds(ids).map(item => item.map((i) => i.content));
    }
    getValueByIds(ids = []) {
        const groups = this.groups.slice();
        return getValueByIds(groups, ids.map(id => [{ id }]), true);
    }
    getParams() {
        let res = assign(this, ['levels']);
        let levels = this.levels.slice();
        if (levels.length < this.levelsNum) {
            levels.push('');
        }
        res.levels = levels.filter(Boolean);
        return res;
    }
}

var questionType;
(function (questionType) {
    questionType[questionType["SINGLE_CHOICE"] = 1] = "SINGLE_CHOICE";
    questionType[questionType["MULTIPLE_CHOICE"] = 2] = "MULTIPLE_CHOICE";
    questionType[questionType["LINKAGE"] = 3] = "LINKAGE";
    questionType[questionType["BLANKS"] = 4] = "BLANKS";
    questionType[questionType["MATRIX_SINGLE_CHOICE"] = 5] = "MATRIX_SINGLE_CHOICE";
    questionType[questionType["MATRIX_MULTIPLE_CHOICE"] = 6] = "MATRIX_MULTIPLE_CHOICE";
    questionType[questionType["SINGLE_TEXT_FILL"] = 7] = "SINGLE_TEXT_FILL";
    questionType[questionType["MULTIPLE_TEXT_FILL"] = 8] = "MULTIPLE_TEXT_FILL";
    questionType[questionType["SINGLE_SELECT"] = 12] = "SINGLE_SELECT";
    questionType[questionType["MULTIPLE_SELECT"] = 13] = "MULTIPLE_SELECT";
    questionType[questionType["ONLY_TEXT"] = 20] = "ONLY_TEXT";
    questionType[questionType["SORT"] = 11] = "SORT";
    questionType[questionType["SCALE"] = 21] = "SCALE";
    questionType[questionType["MATRIX_SCALE"] = 9] = "MATRIX_SCALE";
    questionType[questionType["NPS_SCALE"] = 10] = "NPS_SCALE";
    questionType[questionType["CUSTOM_SINGLE_SCALE"] = 15] = "CUSTOM_SINGLE_SCALE";
    questionType[questionType["CUSTOM_MULTIPLE_SCALE"] = 16] = "CUSTOM_MULTIPLE_SCALE";
    questionType[questionType["TOTAL"] = 119] = "TOTAL";
    questionType[questionType["DATE"] = 17] = "DATE";
    questionType[questionType["UPLOAD_FILE"] = 18] = "UPLOAD_FILE";
    questionType[questionType["HANDWRITING"] = 14] = "HANDWRITING";
    questionType[questionType["CITY_ADDRESS"] = 19] = "CITY_ADDRESS";
    questionType[questionType["MAP"] = 100] = "MAP";
    questionType[questionType["DOWNLOADABLE"] = 112] = "DOWNLOADABLE";
    questionType[questionType["PHONE_VALIDATE"] = 109] = "PHONE_VALIDATE";
    questionType[questionType["CASCADE_REGION"] = 114] = "CASCADE_REGION";
    questionType[questionType["MATRIX_AUTO"] = 102] = "MATRIX_AUTO";
    questionType[questionType["MATRIX_SCROLL"] = 103] = "MATRIX_SCROLL";
    questionType[questionType["MATRIX_GRAVITY"] = 104] = "MATRIX_GRAVITY";
    questionType[questionType["MULTIPLE_BLANKS"] = 105] = "MULTIPLE_BLANKS";
    questionType[questionType["MATRIX_COMPOSE"] = 110] = "MATRIX_COMPOSE";
    questionType[questionType["MATRIX_FILL"] = 107] = "MATRIX_FILL";
    questionType[questionType["IMAGE_CHOICE"] = 113] = "IMAGE_CHOICE";
    questionType[questionType["IMAGE_MULTIPLE_CHOICE"] = 117] = "IMAGE_MULTIPLE_CHOICE";
    questionType[questionType["MATRIX_SELECT_CHOICE"] = 106] = "MATRIX_SELECT_CHOICE";
    questionType[questionType["QUESTION_GROUP"] = 115] = "QUESTION_GROUP";
    questionType[questionType["CLASSIFICATION"] = 111] = "CLASSIFICATION";
    questionType[questionType["PAGE_BREAK"] = 108] = "PAGE_BREAK";
    questionType[questionType["NAME"] = 22] = "NAME";
    questionType[questionType["CELLPHONE"] = 23] = "CELLPHONE";
    questionType[questionType["EMAIL"] = 24] = "EMAIL";
    questionType[questionType["REAL_NAME"] = 26] = "REAL_NAME";
    questionType[questionType["GENDER"] = 27] = "GENDER";
    questionType[questionType["PERMANENT_ADDRESS"] = 28] = "PERMANENT_ADDRESS";
    questionType[questionType["DATE_OF_BIRTH"] = 29] = "DATE_OF_BIRTH";
    questionType[questionType["ID_NUMBER"] = 31] = "ID_NUMBER";
    questionType[questionType["AGE_RANGE"] = 32] = "AGE_RANGE";
    questionType[questionType["DOMICILE"] = 33] = "DOMICILE";
    questionType[questionType["EDUCATIONAL_ATTAINMENT"] = 34] = "EDUCATIONAL_ATTAINMENT";
    questionType[questionType["SPECIALITY"] = 35] = "SPECIALITY";
    questionType[questionType["SCHOOL"] = 36] = "SCHOOL";
    questionType[questionType["INDUSTRY"] = 37] = "INDUSTRY";
    questionType[questionType["JOB"] = 38] = "JOB";
    questionType[questionType["MARITAL_STATUS"] = 39] = "MARITAL_STATUS";
    questionType[questionType["MONTHLY_INCOME_RANGE"] = 40] = "MONTHLY_INCOME_RANGE"; // 个人月收入
})(questionType || (questionType = {}));

const titleMap = new Map();
titleMap.set(questionType.SINGLE_CHOICE, '请选择以下选项');
titleMap.set(questionType.MULTIPLE_CHOICE, '请从以下选项中选择选项');
titleMap.set(questionType.MATRIX_SINGLE_CHOICE, '评价一项新的规则');
titleMap.set(questionType.MATRIX_MULTIPLE_CHOICE, '评价一项新的规则');
titleMap.set(questionType.MATRIX_SELECT_CHOICE, '评价一项新的规则');
titleMap.set(questionType.LINKAGE, '您的常住地址');
titleMap.set(questionType.SINGLE_SELECT, '请选择以下选项');
titleMap.set(questionType.IMAGE_CHOICE, '请选择以下图片');
titleMap.set(questionType.CLASSIFICATION, '请按照分类规则，将左侧选项选入右侧分组中');
titleMap.set(questionType.BLANKS, '请填写以下信息');
titleMap.set(questionType.MATRIX_FILL, '请填写以下内容');
titleMap.set(questionType.MULTIPLE_BLANKS, '请填写以下信息');
titleMap.set(questionType.SINGLE_TEXT_FILL, '请填写以下信息');
titleMap.set(questionType.ONLY_TEXT, '这是一段文本描述');
titleMap.set(questionType.NPS_SCALE, '您向朋友或同事推荐我们的可能性有多大？');
titleMap.set(questionType.MATRIX_SCALE, '评价一项新的规则');
titleMap.set(questionType.SORT, '请给以下选项排序');
titleMap.set(questionType.SCALE, '这条描述与你的匹配度');
titleMap.set(questionType.CUSTOM_SINGLE_SCALE, '请为我们的服务打分');
titleMap.set(questionType.CUSTOM_MULTIPLE_SCALE, '请为我们的服务打分');
titleMap.set(questionType.MATRIX_SCROLL, '评价一项新的规则');
titleMap.set(questionType.MATRIX_AUTO, '请填写你的团队成员信息');
titleMap.set(questionType.MATRIX_COMPOSE, '请填写以下表格');
titleMap.set(questionType.MATRIX_GRAVITY, '评价一项新的规则');
titleMap.set(questionType.TOTAL, '评价一项新的规则');
titleMap.set(questionType.UPLOAD_FILE, '请上传文件');
titleMap.set(questionType.HANDWRITING, '被访者手写签名');
titleMap.set(questionType.DATE, '请选择日期');
titleMap.set(questionType.DOWNLOADABLE, '请下载附件');
titleMap.set(questionType.CITY_ADDRESS, '详细地址');
titleMap.set(questionType.CASCADE_REGION, '请选择');
titleMap.set(questionType.PHONE_VALIDATE, '请输入手机号');
titleMap.set(questionType.MAP, '所在位置');
titleMap.set(questionType.QUESTION_GROUP, '问题组');
titleMap.set(questionType.NAME, '姓名：');
titleMap.set(questionType.CELLPHONE, '手机号：');
titleMap.set(questionType.EMAIL, '邮箱：');
titleMap.set(questionType.GENDER, '性别：');
titleMap.set(questionType.DATE_OF_BIRTH, '出生日期：');
titleMap.set(questionType.AGE_RANGE, '年龄：');
titleMap.set(questionType.PERMANENT_ADDRESS, '请选择您的常住地：');
titleMap.set(questionType.DOMICILE, '请选择您的户籍地：');
titleMap.set(questionType.ID_NUMBER, '您的身份证号是：');
titleMap.set(questionType.EDUCATIONAL_ATTAINMENT, '学历：');
titleMap.set(questionType.SPECIALITY, '您大学所学专业是：');
titleMap.set(questionType.SCHOOL, '您所就读的院校是：');
titleMap.set(questionType.INDUSTRY, '您目前所处行业：');
titleMap.set(questionType.JOB, '您目前的职业是：');
titleMap.set(questionType.MARITAL_STATUS, '婚姻状况：');
titleMap.set(questionType.MONTHLY_INCOME_RANGE, '个人月收入：');
const defaultTitle = titleMap;

const ValidateType = {
    NUM: 'num',
    NULL: null,
    PHONE: 'phone',
    EMAIL: 'email',
    CHAR: 'char',
    CHINESE: 'chinese',
    ID_NUMBER: 'idNumber',
    WEBSITE: 'website',
    TEXT: 'text',
    PASSWORD: 'password' // 密码样式
};

class TextFill {
    constructor(data) {
        this.min_length = data.min_length || '';
        this.max_length = data.max_length || '';
        this.rows = data.rows || 1;
        this.digit = data.digit || '';
        this.validate = data.validate || ValidateType.NULL;
        this.default_text = data.default_text || '';
        this.data_unique = Boolean(data.data_unique || 0);
        this.message_validate = data.message_validate || 0;
        this.placeholder = data.placeholder || '';
        this.setting = data.setting || {
            enableRelation: false
        };
    }
    getParams() {
        let res = assign(this, ['data_unique']);
        res.data_unique = this.data_unique ? 1 : 0;
        res.digit = isNaN(this.digit) ? 0 : Number(this.digit);
        return res;
    }
    getCellParams() {
        return {
            min_length: this.min_length || '',
            max_length: this.max_length || '',
            validate: this.validate,
            rows: this.rows,
            placeholder: this.placeholder
        };
    }
}
class DateIssue {
    constructor(data) {
        this.fillContext = data.fillContext || [];
        this.fillNumber = data.fillNumber || 0;
        this.fillText = '';
        this.numCompareRule = {
            leftEles: [],
            operator: '',
            rightEles: []
        };
        this.context = this.fillContext[0] || {};
    }
    createContext() {
        return {
            dateType: '日',
            digit: 2,
            id: generateId(),
            maxLength: '',
            minLength: '',
            rangeLength: '',
            required: true,
            validate: 'time'
        };
    }
    init() {
        const context = this.createContext();
        this.context = context;
        this.fillContext.push(context);
        this.fillNumber = 1;
    }
    getParams() {
        let res = assign(this, ['context']);
        res.fillContext[0] = this.context;
        return res;
    }
}

class Scale {
    constructor(data) {
        this.correct_answer = data.correct_answer || []; // 质控题正确答案
        this.level = data.level || 0;
        this.items = data.items || [];
        this.labels = this.convertLabels(data.labels || []);
        this.is_rand = data.is_rand || false;
        this.show_unknown = data.showUnknown || false;
        this.unknown_text = data.unknownText || '不清楚';
        this.show_option_desc = typeof data.show_option_desc === 'boolean' ? data.show_option_desc : true;
        this.show_option_value = typeof data.show_option_value === 'boolean' ? data.show_option_value : true;
    }
    convertLabels(labels = []) {
        return labels.map(l => {
            // 2.0 之前的版本是没有 ID 的
            if (!l.id) {
                l = Object.assign({}, { id: generateId() }, l);
            }
            return l;
        });
    }
    getParams() {
        // 前端大部分字段已用 下划线 命名 修改起来不方便
        const res = assign(this, ['show_unknown', 'unknown_text']);
        // @ts-ignore
        res.showUnknown = this.show_unknown;
        // @ts-ignore
        res.unknownText = this.unknown_text;
        return res;
    }
    addItems(texts = []) {
        let items = texts.map(text => {
            return {
                content: getDefaultsContent({ text: text, richText: text }),
                id: generateId()
            };
        });
        this.items.push(...items);
    }
    addItem() {
        let text = getTextByList(this.items, '子题干', item => {
            return item.content.text;
        });
        this.addItems([text]);
    }
    addLabel() {
        let text = getTextByList(this.labels, '选项', t => t.text);
        this.addLabels([text]);
    }
    addLabels(texts = []) {
        texts.forEach(text => {
            this.labels.push({
                id: generateId(),
                text,
                num: this.getLabelNum()
            });
        });
    }
    getLabelNum() {
        let n = 1;
        let labels = this.labels;
        while (labels.find(l => l.num.toString() === n.toString())) {
            n++;
        }
        return n;
    }
    deleteLabel(label) {
        let index = this.labels.findIndex(l => l === label);
        if (index > -1) {
            this.labels.splice(index, 1);
        }
    }
    deleteItemByIndex(index) {
        if (index > -1)
            this.items.splice(index, 1);
    }
    deleteItemByItem(item) {
        this.deleteItemByIndex(this.items.findIndex(i => i.id === item.id));
    }
    initLabels(n, firstLabelText = '', lastLabelText = '') {
        let v = 1;
        let labels = [];
        while (v <= n) {
            labels.push({
                text: '',
                num: v,
                id: generateId()
            });
            v++;
        }
        labels[0].text = firstLabelText;
        labels[labels.length - 1].text = lastLabelText;
        this.labels = labels;
    }
}

export { Cascade, CascadeStyleType, Choice, DateIssue, Scale, TextFill, ValidateType, assign, convertObjToUrlSearch, deepClone, defaultTitle, generateId, getDefaultsContent, getObjFactory, getTextByList, questionType, setIdGenerateFn };
